import SectionMethodColumns from './SectionMethodColumns';
export default SectionMethodColumns;
